import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  activePageData: {
    title: '',
  },
};
export const sliceKey = 'activePage';

export const activePageSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    activePage: (state, { payload }) => {
      try {
        state.activePageData = payload.activePageData;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const { activePage } = activePageSlice.actions;

export default activePageSlice.reducer;
